import {Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {timer} from "rxjs";

import {INAPPBROWSER_CLOSE_BUTTON_CAPTION, INAPPBROWSER_TOOLBAR_COLOR, License} from "../shared/defines/client.const";
import {CordovaService} from "../shared/services/cordova/cordova.service";



function replaceDoubleNewLinesWithBR(text: string): string {
  // 윈도우와 다른 OS 간 줄바꿈 문자 호환을 위해 모든 줄바꿈을 \n으로 통일
  const unifiedNewLinesText = text.replace(/\r\n/g, '\n');

  // 줄바꿈이 2개 연속되는 부분을 <br>로 변경
  // 여기서 \n\n은 연속된 두 줄바꿈을 의미하며, $&는 매치된 문자열(\n\n)을 참조합니다.
  const replacedText = unifiedNewLinesText.replace(/\n\n/g, '<br/><br/>');

  return replacedText;
}

/**
 * 파일 이름으로부터 확장자를 추출하고, 그것이 .md인지 확인하는 함수
 *
 * @param {string} fileName - 검사하고자 하는 파일의 이름
 * @returns {boolean} - 확장자가 .md이면 true, 그렇지 않으면 false를 반환
 */
function isMarkdown(fileName: string): boolean {
  // 파일 확장자 추출
  const extension = fileName.split('.').pop();

  // 확장자가 md인지 확인
  return extension?.toLowerCase() === 'md';
}


@Component({
  selector: 'app-license-view',
  template: `
    <markdown class="md"
              [data]="dataMarkdown"
              (load)="addTarget($event)"></markdown>
    <div class="close-btn" (click)="onCloseBtn($event)"></div>
  `,
})
export class LicenseViewComponent implements OnInit {
  @Input() license?: License;
  @Output() close = new EventEmitter<void>();

  dataMarkdown: string | null = null;

  private get cordova(): Cordova {
    return this.cordovaSvc.cordova as Cordova;
  }

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private http: HttpClient,
    private cordovaSvc: CordovaService,
  ) { }

  async ngOnInit(): Promise<void> {
    if (this.license?.licenseFile) {
      let licenseFile = 'assets/license/' + this.license.licenseFile;

      if (this.cordovaSvc.onCordova) {
        licenseFile = this.cordova.file.applicationDirectory + 'www/' + licenseFile;
        console.warn('licenseFile:', licenseFile);

        let data = await this.parseFile(licenseFile);
        this.setMarkdown(data);
      }
      else {
        console.warn('licenseFile:', licenseFile);
        this.http.get(licenseFile, {responseType: 'text'}).subscribe((data: string) => {

          this.setMarkdown(data);
        });
      }
    }
    else {
      this.dataMarkdown = "";
    }
  }


  private setMarkdown(data: string) {
    console.warn('setMarkdown(data ->)', data);

    if (!isMarkdown(this.license.licenseFile!)) {
      data = replaceDoubleNewLinesWithBR(data);
    }
    this.dataMarkdown = data;
    console.warn('srcMarkdown:', this.dataMarkdown);

    timer(500).subscribe(() => {
      this.addTarget();
    });
  }

  /**
   * markdown에서 a 태그에 target="_blank" 속성을 추가한다.
   *
   * 문제점: markdown (load) 가 불려지지 않는다.
   *
   * @param $event
   */
  addTarget($event: any = null) {
    console.warn('addTarget()', $event);

    const anchorElements = this.el.nativeElement.querySelectorAll('a');
    anchorElements.forEach((anchorLink) => {
      this.renderer.listen(anchorLink, 'click', (event) => {
        event.preventDefault();
        const url = anchorLink.getAttribute('href');
        if (this.cordovaSvc.onCordova) {
          const options = [
            'location=no',
            'fullscreen=yes',
            'toolbartranslucent=no',
            `toolbarcolor=${INAPPBROWSER_TOOLBAR_COLOR}`,
            `closebuttoncaption=${INAPPBROWSER_CLOSE_BUTTON_CAPTION}`,
            'hardwareback=yes',
            'hidenavigationbuttons=yes',
          ].join(',');

          this.cordovaSvc.cordova.InAppBrowser.open(url, '_blank', options);
        }
        else {
          window.open(url, '_blank');
        }
      });
    });
  }

  onCloseBtn($event: MouseEvent) {
    $event.stopPropagation();
    $event.preventDefault();

    this.close.emit();
  }

  private async parseFile(path: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      window.resolveLocalFileSystemURL(path, (fileEntry: FileEntry) => {
        console.log('window.resolveLocalFileSystemURL(fileEntry ->)', fileEntry);

        fileEntry.file(file => {
          console.log('fileEntry.file(file ->)', file);
          const reader = new FileReader();

          reader.onloadend = function(e): any {
            console.log('reader.readAsText().onloadend(e ->)', e, this.result);
            resolve(this.result as string); // ArrayBuffer가 아닌 string으로 결과를 반환
          };
          reader.onerror = (e): any => reject(e);
          reader.readAsText(file); // readAsArrayBuffer 대신 readAsText 사용
        }, (err: FileError) => reject(err));
      }, (err: FileError) => {
        console.error('window.resolveLocalFileSystemURL fail', err, path);
        reject(err);
      });
    });
  }
}
